import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserLoginComponent } from './user-login/user-login.component';
import { UserSignUpComponent } from './user-sign-up/user-sign-up.component';
import { HomeComponent } from './home/home.component';
import { MainComponent } from './main/main.component';
import { RoutingguardService } from './routingguard.service';


const routes: Routes = [ { path: '',component: MainComponent, children: [
  {path: '', component:HomeComponent, pathMatch: 'full'},
  {path:'home',component:HomeComponent
},{path:'login',component:UserLoginComponent,canActivate:[RoutingguardService]
 },
 
]}
,{path:'signUp',component:UserSignUpComponent}

]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
